import { render, staticRenderFns } from "./DocusignAddTemplateSignHere.vue?vue&type=template&id=961df6f4&"
import script from "./DocusignAddTemplateSignHere.vue?vue&type=script&lang=ts&"
export * from "./DocusignAddTemplateSignHere.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports